import {
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { Mapping, MappingType } from 'src/containers/ProjectDiagram/types/data';

export const getMappingType = (mapping: Mapping | null) => {
  if (!mapping) {
    return MappingType.NONE;
  }

  const targetKey = mapping.to;

  if (!targetKey) {
    return MappingType.UNCONNECTED;
  }

  if (targetKey.startsWith(NodeCategory.MODEL_CONCEPT_CLASS)) {
    return MappingType.CLASS;
  }

  if (
    targetKey.startsWith(LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL)
  ) {
    return MappingType.RELATIONSHIP;
  }

  return MappingType.UNCONNECTED;
};
